<template>
    <div id="app" v-if="accessGranted">
        <router-view name="header"></router-view>
        <main>
            <fade-transition origin="center" mode="out-in" :duration="250">
                <router-view/>
            </fade-transition>
        </main>
        <router-view name="footer"></router-view>
    </div>
    <div id="app" v-else>
      <body class="text-center custom-body">
        <div class="form-signin">
          <img class="mb-4" src="/img/APG_logo_transparant.png" alt="" height="72">
          <input type="password" id="inputPassword" class="form-control" placeholder="Passphrase" v-model="passphrase" required>
          <button class="btn btn-lg btn-primary btn-block" v-on:click="checkPassphrase">Enter</button>
        </div>
      </body>
    </div>
</template>
<script>
import { FadeTransition } from "vue2-transitions";
import variables from "./variables.js";

export default {
  data: {
    accessGranted : false,
    passphrase: ""
  },
  created() {
    this.accessGranted = variables.isAccessible();
  },
  methods: {
    checkPassphrase(){
      if (variables.checkPassphrase(this.passphrase)){
        location.reload();
      }
    }
  },
  components: {
    FadeTransition
  }
};
</script>

<style>

.custom-body {
  height: 100%;
  display: -ms-flexbox;
  display: -webkit-box;
  display: flex;
  -ms-flex-align: center;
  -ms-flex-pack: center;
  -webkit-box-align: center;
  align-items: center;
  -webkit-box-pack: center;
  justify-content: center;
  padding-top: 40px;
  padding-bottom: 40px;
}

.form-signin {
  width: 100%;
  max-width: 330px;
  padding: 15px;
  margin: 0 auto;
}
.form-signin .checkbox {
  font-weight: 400;
}
.form-signin .form-control {
  position: relative;
  box-sizing: border-box;
  height: auto;
  padding: 10px;
  font-size: 16px;
}
.form-signin .form-control:focus {
  z-index: 2;
}
.form-signin input[type="email"] {
  margin-bottom: -1px;
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.form-signin input[type="password"] {
  margin-bottom: 10px;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
</style>
